import { useContext } from "react";
import PlayerContext from "../context/player-context";

const usePlayerContext = () => {
    return useContext(PlayerContext);
};

export default usePlayerContext;
